var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnion = function SvgUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 3.857V9H4.667V6.429h-2V9H0V3.857l3.667-2.571zM12 9H8.333V3.375L5 1.031V0h7zM9 2.893h1v-.964H9z"
  })));
};
export default SvgUnion;